import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import {
  isChunkLoadError,
  recoverFromChunkLoadError,
} from './chunkLoadRecovery';

export function RouteErrorPage() {
  const error = useRouteError();
  const chunkLoadFailed = isChunkLoadError(error);

  useEffect(() => {
    if (chunkLoadFailed) recoverFromChunkLoadError(error);
  }, [chunkLoadFailed, error]);

  return (
    <main className="route-error" role="alert">
      <img className="route-error__logo" src="/Logo_WMS.png" alt="WMS" />
      <div className="route-error__card">
        <h1>
          {chunkLoadFailed
            ? 'Aplikacijo je treba osvežiti'
            : 'Prišlo je do nepričakovane napake'}
        </h1>
        <p>
          {chunkLoadFailed
            ? 'Medtem je bila objavljena nova različica aplikacije. Osveži stran, da se naložijo aktualne datoteke.'
            : 'Strani trenutno ni mogoče prikazati. Osveži aplikacijo in poskusi znova.'}
        </p>
        <button
          className="primary-button"
          type="button"
          onClick={() => window.location.reload()}
        >
          Osveži aplikacijo
        </button>
      </div>
    </main>
  );
}
